import React from "react";
import "./errorPages.css";

const ServerErrorPage = ({ onRetry }) => (
  <div className="error-page-container">
    <div className="error-icon" aria-label="Warning" role="img">
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="22" stroke="#FFD600" strokeWidth="4" fill="#FFF8E1" />
    <path d="M24 14v12" stroke="#FFD600" strokeWidth="3" strokeLinecap="round"/>
    <circle cx="24" cy="32" r="2" fill="#FFD600" />
  </svg>
</div>
    <h1>Server Error</h1>
    <h2>Something went wrong</h2>
    <p>A connection or server error occurred. Please try again later.</p>
    {onRetry && <button className="error-btn" onClick={onRetry}>Try Again</button>}
  </div>
);

export default ServerErrorPage;
